var map = {
	"./MathBowl/Grade10/2025/premium1000/math_quiz.json": 798,
	"./MathBowl/Grade11/2025/premium1000/math_quiz.json": 799,
	"./MathBowl/Grade12/2025/premium1000/math_quiz.json": 800,
	"./MathBowl/Grade4/2017/premium1000/mathbowl 2017 area.json": 801,
	"./MathBowl/Grade4/2020/premium1000/mathbowl 2020 area.json": 802,
	"./MathBowl/Grade4/2025/premium1000/math_quiz.json": 803,
	"./MathBowl/Grade4/2026/premium1000/MathBowl 2026 Invitational.json": 804,
	"./MathBowl/Grade4/2026/premium1000/MathBowl19.json": 805,
	"./MathBowl/Grade4/2026/premium1000/mathbowl 2026 ai.json": 806,
	"./MathBowl/Grade4/classic/MathBowl1.json": 807,
	"./MathBowl/Grade4/classic/MathBowl10.json": 808,
	"./MathBowl/Grade4/classic/MathBowl11.json": 809,
	"./MathBowl/Grade4/classic/MathBowl12.json": 810,
	"./MathBowl/Grade4/classic/MathBowl13.json": 811,
	"./MathBowl/Grade4/classic/MathBowl14.json": 812,
	"./MathBowl/Grade4/classic/MathBowl15.json": 813,
	"./MathBowl/Grade4/classic/MathBowl16.json": 814,
	"./MathBowl/Grade4/classic/MathBowl17.json": 815,
	"./MathBowl/Grade4/classic/MathBowl18.json": 816,
	"./MathBowl/Grade4/classic/MathBowl19.json": 817,
	"./MathBowl/Grade4/classic/MathBowl2.json": 818,
	"./MathBowl/Grade4/classic/MathBowl3.json": 819,
	"./MathBowl/Grade4/classic/MathBowl4.json": 820,
	"./MathBowl/Grade4/classic/MathBowl5.json": 821,
	"./MathBowl/Grade4/classic/MathBowl6.json": 822,
	"./MathBowl/Grade4/classic/MathBowl7.json": 823,
	"./MathBowl/Grade4/classic/MathBowl8.json": 824,
	"./MathBowl/Grade4/classic/MathBowl9.json": 825,
	"./MathBowl/Grade5/2017/premium1000/mathbowl 2017 area.json": 826,
	"./MathBowl/Grade5/2020/premium1000/mathbowl 2020 area.json": 827,
	"./MathBowl/Grade5/2025/premium1000/math_quiz.json": 828,
	"./MathBowl/Grade5/2026/premium1000/MathBowl 2026 Invitational.json": 829,
	"./MathBowl/Grade5/2026/premium1000/mathbowl 2026 ai.json": 830,
	"./MathBowl/Grade5/classic/MathBowl1.json": 831,
	"./MathBowl/Grade5/classic/MathBowl10.json": 832,
	"./MathBowl/Grade5/classic/MathBowl11.json": 833,
	"./MathBowl/Grade5/classic/MathBowl12.json": 834,
	"./MathBowl/Grade5/classic/MathBowl13.json": 835,
	"./MathBowl/Grade5/classic/MathBowl14.json": 836,
	"./MathBowl/Grade5/classic/MathBowl15.json": 837,
	"./MathBowl/Grade5/classic/MathBowl16.json": 838,
	"./MathBowl/Grade5/classic/MathBowl17.json": 839,
	"./MathBowl/Grade5/classic/MathBowl18.json": 840,
	"./MathBowl/Grade5/classic/MathBowl19.json": 841,
	"./MathBowl/Grade5/classic/MathBowl2.json": 842,
	"./MathBowl/Grade5/classic/MathBowl3.json": 843,
	"./MathBowl/Grade5/classic/MathBowl4.json": 844,
	"./MathBowl/Grade5/classic/MathBowl5.json": 845,
	"./MathBowl/Grade5/classic/MathBowl6.json": 846,
	"./MathBowl/Grade5/classic/MathBowl7.json": 847,
	"./MathBowl/Grade5/classic/MathBowl8.json": 848,
	"./MathBowl/Grade5/classic/MathBowl9.json": 849,
	"./MathBowl/Grade6/2025/premium1000/math_quiz.json": 850,
	"./MathBowl/Grade7/2025/premium1000/math_quiz.json": 851,
	"./MathBowl/Grade8/2025/premium1000/math_quiz.json": 852,
	"./MathBowl/Grade9/2025/premium1000/math_quiz.json": 853,
	"./ScienceBowl/Grade7/premium1000/2007_Energy-Category.json": 854,
	"./ScienceBowl/Grade7/premium1000/2007_Round-10C-MS.json": 855,
	"./ScienceBowl/Grade7/premium1000/2007_Round-11C-MS.json": 856,
	"./ScienceBowl/Grade7/premium1000/2007_Round-12C-MS.json": 857,
	"./ScienceBowl/Grade7/premium1000/2007_Round-13C-MS.json": 858,
	"./ScienceBowl/Grade7/premium1000/2007_Round-14C-MS.json": 859,
	"./ScienceBowl/Grade7/premium1000/2007_Round-15C-MS.json": 860,
	"./ScienceBowl/Grade7/premium1000/2007_Round-1C-MS.json": 861,
	"./ScienceBowl/Grade7/premium1000/2007_Round-2C-MS.json": 862,
	"./ScienceBowl/Grade7/premium1000/2007_Round-4C-MS.json": 863,
	"./ScienceBowl/Grade7/premium1000/2007_Round-5C-MS.json": 864,
	"./ScienceBowl/Grade7/premium1000/2007_Round-6C-MS.json": 865,
	"./ScienceBowl/Grade7/premium1000/2007_Round-7C-MS.json": 866,
	"./ScienceBowl/Grade7/premium1000/2007_Round-8C-MS.json": 867,
	"./ScienceBowl/Grade7/premium1000/2007_Round-9C-MS.json": 868,
	"./ScienceBowl/Grade7/premium1000/2007_Round1.json": 869,
	"./ScienceBowl/Grade7/premium1000/2008_sample_questions_r1.json": 870,
	"./ScienceBowl/Grade7/premium1000/2008_sample_questions_r10.json": 871,
	"./ScienceBowl/Grade7/premium1000/2008_sample_questions_r2.json": 872,
	"./ScienceBowl/Grade7/premium1000/2008_sample_questions_r3.json": 873,
	"./ScienceBowl/Grade7/premium1000/2008_sample_questions_r4.json": 874,
	"./ScienceBowl/Grade7/premium1000/2008_sample_questions_r5.json": 875,
	"./ScienceBowl/Grade7/premium1000/2008_sample_questions_r6.json": 876,
	"./ScienceBowl/Grade7/premium1000/2008_sample_questions_r7.json": 877,
	"./ScienceBowl/Grade7/premium1000/2008_sample_questions_r8.json": 878,
	"./ScienceBowl/Grade7/premium1000/2008_sample_questions_r9.json": 879,
	"./ScienceBowl/Grade7/premium1000/2009_m_round01.json": 880,
	"./ScienceBowl/Grade7/premium1000/2009_m_round02.json": 881,
	"./ScienceBowl/Grade7/premium1000/2009_m_round03.json": 882,
	"./ScienceBowl/Grade7/premium1000/2009_m_round04.json": 883,
	"./ScienceBowl/Grade7/premium1000/2009_m_round05.json": 884,
	"./ScienceBowl/Grade7/premium1000/2009_m_round06.json": 885,
	"./ScienceBowl/Grade7/premium1000/2009_m_round07.json": 886,
	"./ScienceBowl/Grade7/premium1000/2009_m_round08.json": 887,
	"./ScienceBowl/Grade7/premium1000/2009_m_round09.json": 888,
	"./ScienceBowl/Grade7/premium1000/2009_m_round10.json": 889,
	"./ScienceBowl/Grade7/premium1000/2009_m_round11.json": 890,
	"./ScienceBowl/Grade7/premium1000/2009_m_round12.json": 891,
	"./ScienceBowl/Grade7/premium1000/2009_m_round13.json": 892,
	"./ScienceBowl/Grade7/premium1000/2009_m_round14.json": 893,
	"./ScienceBowl/Grade7/premium1000/2009_m_round15.json": 894,
	"./ScienceBowl/Grade7/premium1000/2009_m_round16.json": 895,
	"./ScienceBowl/Grade7/premium1000/2009_m_round17.json": 896,
	"./ScienceBowl/Grade7/premium1000/2009_m_round18.json": 897,
	"./ScienceBowl/Grade7/premium1000/2010_Round1.json": 898,
	"./ScienceBowl/Grade7/premium1000/2010_Round10.json": 899,
	"./ScienceBowl/Grade7/premium1000/2010_Round11.json": 900,
	"./ScienceBowl/Grade7/premium1000/2010_Round12.json": 901,
	"./ScienceBowl/Grade7/premium1000/2010_Round13.json": 902,
	"./ScienceBowl/Grade7/premium1000/2010_Round14.json": 903,
	"./ScienceBowl/Grade7/premium1000/2010_Round15.json": 904,
	"./ScienceBowl/Grade7/premium1000/2010_Round16.json": 905,
	"./ScienceBowl/Grade7/premium1000/2010_Round17.json": 906,
	"./ScienceBowl/Grade7/premium1000/2010_Round2.json": 907,
	"./ScienceBowl/Grade7/premium1000/2010_Round3.json": 908,
	"./ScienceBowl/Grade7/premium1000/2010_Round4.json": 909,
	"./ScienceBowl/Grade7/premium1000/2010_Round5.json": 910,
	"./ScienceBowl/Grade7/premium1000/2010_Round6.json": 911,
	"./ScienceBowl/Grade7/premium1000/2010_Round7.json": 912,
	"./ScienceBowl/Grade7/premium1000/2010_Round8.json": 913,
	"./ScienceBowl/Grade7/premium1000/2010_Round9.json": 914,
	"./ScienceBowl/Grade7/premium1000/2011_Round1.json": 915,
	"./ScienceBowl/Grade7/premium1000/2011_Round10.json": 916,
	"./ScienceBowl/Grade7/premium1000/2011_Round11.json": 917,
	"./ScienceBowl/Grade7/premium1000/2011_Round12.json": 918,
	"./ScienceBowl/Grade7/premium1000/2011_Round13.json": 919,
	"./ScienceBowl/Grade7/premium1000/2011_Round14.json": 920,
	"./ScienceBowl/Grade7/premium1000/2011_Round15.json": 921,
	"./ScienceBowl/Grade7/premium1000/2011_Round2.json": 922,
	"./ScienceBowl/Grade7/premium1000/2011_Round3.json": 923,
	"./ScienceBowl/Grade7/premium1000/2011_Round4.json": 924,
	"./ScienceBowl/Grade7/premium1000/2011_Round5.json": 925,
	"./ScienceBowl/Grade7/premium1000/2011_Round6.json": 926,
	"./ScienceBowl/Grade7/premium1000/2011_Round7.json": 927,
	"./ScienceBowl/Grade7/premium1000/2011_Round8.json": 928,
	"./ScienceBowl/Grade7/premium1000/2011_Round9.json": 929,
	"./ScienceBowl/Grade7/premium1000/2012_MS_Round-1.json": 930,
	"./ScienceBowl/Grade7/premium1000/2012_MS_Round-2.json": 931,
	"./ScienceBowl/Grade7/premium1000/2012_Round10.json": 932,
	"./ScienceBowl/Grade7/premium1000/2012_Round11.json": 933,
	"./ScienceBowl/Grade7/premium1000/2012_Round12.json": 934,
	"./ScienceBowl/Grade7/premium1000/2012_Round13.json": 935,
	"./ScienceBowl/Grade7/premium1000/2012_Round14.json": 936,
	"./ScienceBowl/Grade7/premium1000/2012_Round15.json": 937,
	"./ScienceBowl/Grade7/premium1000/2012_Round16.json": 938,
	"./ScienceBowl/Grade7/premium1000/2012_Round17.json": 939,
	"./ScienceBowl/Grade7/premium1000/2012_Round3.json": 940,
	"./ScienceBowl/Grade7/premium1000/2012_Round4.json": 941,
	"./ScienceBowl/Grade7/premium1000/2012_Round5.json": 942,
	"./ScienceBowl/Grade7/premium1000/2012_Round6.json": 943,
	"./ScienceBowl/Grade7/premium1000/2012_Round7.json": 944,
	"./ScienceBowl/Grade7/premium1000/2012_Round8.json": 945,
	"./ScienceBowl/Grade7/premium1000/2012_Round9.json": 946,
	"./ScienceBowl/Grade7/premium1000/2013_MS_Round-10.json": 947,
	"./ScienceBowl/Grade7/premium1000/2013_MS_Round-11.json": 948,
	"./ScienceBowl/Grade7/premium1000/2013_MS_Round-12.json": 949,
	"./ScienceBowl/Grade7/premium1000/2013_MS_Round-13.json": 950,
	"./ScienceBowl/Grade7/premium1000/2013_MS_Round-14.json": 951,
	"./ScienceBowl/Grade7/premium1000/2013_MS_Round-15.json": 952,
	"./ScienceBowl/Grade7/premium1000/2013_MS_Round-3.json": 953,
	"./ScienceBowl/Grade7/premium1000/2013_MS_Round-4.json": 954,
	"./ScienceBowl/Grade7/premium1000/2013_MS_Round-5.json": 955,
	"./ScienceBowl/Grade7/premium1000/2013_MS_Round-6.json": 956,
	"./ScienceBowl/Grade7/premium1000/2013_MS_Round-7.json": 957,
	"./ScienceBowl/Grade7/premium1000/2013_MS_Round-8.json": 958,
	"./ScienceBowl/Grade7/premium1000/2013_MS_Round-9.json": 959,
	"./ScienceBowl/Grade7/premium1000/2013_Round-1-A.json": 960,
	"./ScienceBowl/Grade7/premium1000/2013_Round-2-A.json": 961,
	"./ScienceBowl/Grade7/premium1000/2014_Round-10-A.json": 962,
	"./ScienceBowl/Grade7/premium1000/2014_Round-11-A.json": 963,
	"./ScienceBowl/Grade7/premium1000/2014_Round-12-A.json": 964,
	"./ScienceBowl/Grade7/premium1000/2014_Round-13-A.json": 965,
	"./ScienceBowl/Grade7/premium1000/2014_Round-14-A.json": 966,
	"./ScienceBowl/Grade7/premium1000/2014_Round-15-A.json": 967,
	"./ScienceBowl/Grade7/premium1000/2014_Round-16-A.json": 968,
	"./ScienceBowl/Grade7/premium1000/2014_Round-17-A.json": 969,
	"./ScienceBowl/Grade7/premium1000/2014_Round-3-A.json": 970,
	"./ScienceBowl/Grade7/premium1000/2014_Round-4-A.json": 971,
	"./ScienceBowl/Grade7/premium1000/2014_Round-5-A.json": 972,
	"./ScienceBowl/Grade7/premium1000/2014_Round-6-A.json": 973,
	"./ScienceBowl/Grade7/premium1000/2014_Round-7-A.json": 974,
	"./ScienceBowl/Grade7/premium1000/2014_Round-8-A.json": 975,
	"./ScienceBowl/Grade7/premium1000/2014_Round-9-A.json": 976,
	"./ScienceBowl/Grade7/premium1000/2015_RegionalMS_1.json": 977,
	"./ScienceBowl/Grade7/premium1000/2015_RegionalMS_10A.json": 978,
	"./ScienceBowl/Grade7/premium1000/2015_RegionalMS_11A.json": 979,
	"./ScienceBowl/Grade7/premium1000/2015_RegionalMS_12A.json": 980,
	"./ScienceBowl/Grade7/premium1000/2015_RegionalMS_13A.json": 981,
	"./ScienceBowl/Grade7/premium1000/2015_RegionalMS_14A.json": 982,
	"./ScienceBowl/Grade7/premium1000/2015_RegionalMS_15A.json": 983,
	"./ScienceBowl/Grade7/premium1000/2015_RegionalMS_16A.json": 984,
	"./ScienceBowl/Grade7/premium1000/2015_RegionalMS_17A.json": 985,
	"./ScienceBowl/Grade7/premium1000/2015_RegionalMS_2.json": 986,
	"./ScienceBowl/Grade7/premium1000/2015_RegionalMS_3A.json": 987,
	"./ScienceBowl/Grade7/premium1000/2015_RegionalMS_4A.json": 988,
	"./ScienceBowl/Grade7/premium1000/2015_RegionalMS_5A.json": 989,
	"./ScienceBowl/Grade7/premium1000/2015_RegionalMS_6A.json": 990,
	"./ScienceBowl/Grade7/premium1000/2015_RegionalMS_7A.json": 991,
	"./ScienceBowl/Grade7/premium1000/2015_RegionalMS_8A.json": 992,
	"./ScienceBowl/Grade7/premium1000/2015_RegionalMS_9A.json": 993,
	"./ScienceBowl/Grade7/premium1000/2016_10A_MS_Reg_2016.json": 994,
	"./ScienceBowl/Grade7/premium1000/2016_11A_MS_Reg_2016.json": 995,
	"./ScienceBowl/Grade7/premium1000/2016_12A_MS_Reg_2016.json": 996,
	"./ScienceBowl/Grade7/premium1000/2016_13A_MS_Reg_2016.json": 997,
	"./ScienceBowl/Grade7/premium1000/2016_14A_MS_Reg_2016.json": 998,
	"./ScienceBowl/Grade7/premium1000/2016_15A_MS_Reg_2016.json": 999,
	"./ScienceBowl/Grade7/premium1000/2016_16A_MS_Reg_2016.json": 1000,
	"./ScienceBowl/Grade7/premium1000/2016_17A_MS_Reg_2016.json": 1001,
	"./ScienceBowl/Grade7/premium1000/2016_1A_MS_Reg_2016.json": 1002,
	"./ScienceBowl/Grade7/premium1000/2016_2A_MS_Reg_2016.json": 1003,
	"./ScienceBowl/Grade7/premium1000/2016_3A_MS_Reg_2016.json": 1004,
	"./ScienceBowl/Grade7/premium1000/2016_4A_MS_Reg_2016.json": 1005,
	"./ScienceBowl/Grade7/premium1000/2016_5A_MS_Reg_2016.json": 1006,
	"./ScienceBowl/Grade7/premium1000/2016_6A_MS_Reg_2016.json": 1007,
	"./ScienceBowl/Grade7/premium1000/2016_7A_MS_Reg_2016.json": 1008,
	"./ScienceBowl/Grade7/premium1000/2016_8A_MS_Reg_2016.json": 1009,
	"./ScienceBowl/Grade7/premium1000/2016_9A_MS_Reg_2016.json": 1010,
	"./ScienceBowl/Grade7/premium1000/2016_MS_1.json": 1011,
	"./ScienceBowl/Grade7/premium1000/2016_MS_2.json": 1012,
	"./ScienceBowl/Grade7/premium1000/2017_MSRound-1.json": 1013,
	"./ScienceBowl/Grade7/premium1000/2017_MSRound-2.json": 1014,
	"./ScienceBowl/Grade7/premium1000/2017_MS_10A.json": 1015,
	"./ScienceBowl/Grade7/premium1000/2017_MS_11A.json": 1016,
	"./ScienceBowl/Grade7/premium1000/2017_MS_12A.json": 1017,
	"./ScienceBowl/Grade7/premium1000/2017_MS_13A.json": 1018,
	"./ScienceBowl/Grade7/premium1000/2017_MS_14A.json": 1019,
	"./ScienceBowl/Grade7/premium1000/2017_MS_15A.json": 1020,
	"./ScienceBowl/Grade7/premium1000/2017_MS_16A.json": 1021,
	"./ScienceBowl/Grade7/premium1000/2017_MS_17A.json": 1022,
	"./ScienceBowl/Grade7/premium1000/2017_MS_3A.json": 1023,
	"./ScienceBowl/Grade7/premium1000/2017_MS_4A.json": 1024,
	"./ScienceBowl/Grade7/premium1000/2017_MS_5A.json": 1025,
	"./ScienceBowl/Grade7/premium1000/2017_MS_6A.json": 1026,
	"./ScienceBowl/Grade7/premium1000/2017_MS_7A.json": 1027,
	"./ScienceBowl/Grade7/premium1000/2017_MS_8A.json": 1028,
	"./ScienceBowl/Grade7/premium1000/2017_MS_9A.json": 1029,
	"./ScienceBowl/Grade7/premium1000/2018_2019-NSB-MSR-Round-1A.json": 1030,
	"./ScienceBowl/Grade7/premium1000/2018_2019-NSB-MSR-Round-2A.json": 1031,
	"./ScienceBowl/Grade7/premium1000/2018_MSRound-10.json": 1032,
	"./ScienceBowl/Grade7/premium1000/2018_MSRound-11.json": 1033,
	"./ScienceBowl/Grade7/premium1000/2018_MSRound-12.json": 1034,
	"./ScienceBowl/Grade7/premium1000/2018_MSRound-13.json": 1035,
	"./ScienceBowl/Grade7/premium1000/2018_MSRound-14.json": 1036,
	"./ScienceBowl/Grade7/premium1000/2018_MSRound-15.json": 1037,
	"./ScienceBowl/Grade7/premium1000/2018_MSRound-16.json": 1038,
	"./ScienceBowl/Grade7/premium1000/2018_MSRound-17.json": 1039,
	"./ScienceBowl/Grade7/premium1000/2018_MSRound-3.json": 1040,
	"./ScienceBowl/Grade7/premium1000/2018_MSRound-4.json": 1041,
	"./ScienceBowl/Grade7/premium1000/2018_MSRound-5.json": 1042,
	"./ScienceBowl/Grade7/premium1000/2018_MSRound-6.json": 1043,
	"./ScienceBowl/Grade7/premium1000/2018_MSRound-7.json": 1044,
	"./ScienceBowl/Grade7/premium1000/2018_MSRound-8.json": 1045,
	"./ScienceBowl/Grade7/premium1000/2018_MSRound-9.json": 1046,
	"./ScienceBowl/Grade7/premium1000/2019-NSB-MSR-Round-10A.json": 1047,
	"./ScienceBowl/Grade7/premium1000/2019-NSB-MSR-Round-11A.json": 1048,
	"./ScienceBowl/Grade7/premium1000/2019-NSB-MSR-Round-12A.json": 1049,
	"./ScienceBowl/Grade7/premium1000/2019-NSB-MSR-Round-13A.json": 1050,
	"./ScienceBowl/Grade7/premium1000/2019-NSB-MSR-Round-14A.json": 1051,
	"./ScienceBowl/Grade7/premium1000/2019-NSB-MSR-Round-15A.json": 1052,
	"./ScienceBowl/Grade7/premium1000/2019-NSB-MSR-Round-16A.json": 1053,
	"./ScienceBowl/Grade7/premium1000/2019-NSB-MSR-Round-17A.json": 1054,
	"./ScienceBowl/Grade7/premium1000/2019-NSB-MSR-Round-1A.json": 1055,
	"./ScienceBowl/Grade7/premium1000/2019-NSB-MSR-Round-2A.json": 1056,
	"./ScienceBowl/Grade7/premium1000/2019-NSB-MSR-Round-3A.json": 1057,
	"./ScienceBowl/Grade7/premium1000/2019-NSB-MSR-Round-4A.json": 1058,
	"./ScienceBowl/Grade7/premium1000/2019-NSB-MSR-Round-5A.json": 1059,
	"./ScienceBowl/Grade7/premium1000/2019-NSB-MSR-Round-6A.json": 1060,
	"./ScienceBowl/Grade7/premium1000/2019-NSB-MSR-Round-7A.json": 1061,
	"./ScienceBowl/Grade7/premium1000/2019-NSB-MSR-Round-8A.json": 1062,
	"./ScienceBowl/Grade7/premium1000/2019-NSB-MSR-Round-9A.json": 1063,
	"./ScienceBowl/Grade7/premium1000/2019_de1_for_web.json": 1064,
	"./ScienceBowl/Grade7/premium1000/2019_de3_for_web.json": 1065,
	"./ScienceBowl/Grade7/premium1000/2019_rr2_for_web.json": 1066,
	"./ScienceBowl/Grade7/premium1000/2019_rr5_for_web.json": 1067,
	"./ScienceBowl/Grade7/premium2000/Biology.json": 1068,
	"./ScienceBowl/Grade7/premium2000/Earth and Space.json": 1069,
	"./ScienceBowl/Grade7/premium2000/EarthScience.json": 1070,
	"./ScienceBowl/Grade7/premium2000/Energy.json": 1071,
	"./ScienceBowl/Grade7/premium2000/GeneralScience.json": 1072,
	"./ScienceBowl/Grade7/premium2000/LifeScience.json": 1073,
	"./ScienceBowl/Grade7/premium2000/Mathematics.json": 1074,
	"./ScienceBowl/Grade7/premium2000/PhysicalScience.json": 1075,
	"./SpellBowl/Grade1/2023/premium300/Elementary Word List 2023.json": 279,
	"./SpellBowl/Grade1/2024/premium300/AI Generated Complex Elementary Word List 2024.json": 280,
	"./SpellBowl/Grade1/2024/premium300/Elementary Word List 2024 with hyphens and spaces.json": 281,
	"./SpellBowl/Grade1/2024/premium300/Elementary Word List 2024 with hyphens.json": 282,
	"./SpellBowl/Grade1/2024/premium300/Elementary Word List 2024 with spaces.json": 283,
	"./SpellBowl/Grade1/2024/premium300/Elementary Word List 2024 with upper cases.json": 284,
	"./SpellBowl/Grade1/2024/premium300/Elementary Word List 2024.json": 285,
	"./SpellBowl/Grade10/2023/premium300/Senior Word List 2023.json": 286,
	"./SpellBowl/Grade10/2024/premium300/AI Generated Complex Senior Word List 2024.json": 287,
	"./SpellBowl/Grade10/2024/premium300/Senior Word List 2024 with hyphens and spaces.json": 288,
	"./SpellBowl/Grade10/2024/premium300/Senior Word List 2024 with hyphens.json": 289,
	"./SpellBowl/Grade10/2024/premium300/Senior Word List 2024 with spaces.json": 290,
	"./SpellBowl/Grade10/2024/premium300/Senior Word List 2024 with upper cases.json": 291,
	"./SpellBowl/Grade10/2024/premium300/Senior Word List 2024.json": 292,
	"./SpellBowl/Grade10/2025/premium1000/Senior Word List 2025.json": 293,
	"./SpellBowl/Grade10/2025/premium1000/Senior Word List 2025.json with hyphens and spaces.json": 294,
	"./SpellBowl/Grade10/2025/premium1000/Senior Word List 2025.json with upper cases.json": 295,
	"./SpellBowl/Grade10/2025/premium1000/Senior Word List 2025_filtered.json": 296,
	"./SpellBowl/Grade10/2026/premium0/Senior Word List 2026.json": 297,
	"./SpellBowl/Grade10/2026/premium0/Senior Word List 2026.json with hyphens and spaces.json": 298,
	"./SpellBowl/Grade10/2026/premium0/Senior Word List 2026.json with upper cases.json": 299,
	"./SpellBowl/Grade11/2023/premium300/Senior Word List 2023.json": 300,
	"./SpellBowl/Grade11/2024/premium300/AI Generated Complex Senior Word List 2024.json": 301,
	"./SpellBowl/Grade11/2024/premium300/Senior Word List 2024 with hyphens and spaces.json": 302,
	"./SpellBowl/Grade11/2024/premium300/Senior Word List 2024 with hyphens.json": 303,
	"./SpellBowl/Grade11/2024/premium300/Senior Word List 2024 with spaces.json": 304,
	"./SpellBowl/Grade11/2024/premium300/Senior Word List 2024 with upper cases.json": 305,
	"./SpellBowl/Grade11/2024/premium300/Senior Word List 2024.json": 306,
	"./SpellBowl/Grade11/2025/premium1000/Senior Word List 2025.json": 307,
	"./SpellBowl/Grade11/2025/premium1000/Senior Word List 2025.json with hyphens and spaces.json": 308,
	"./SpellBowl/Grade11/2025/premium1000/Senior Word List 2025.json with upper cases.json": 309,
	"./SpellBowl/Grade11/2025/premium1000/Senior Word List 2025_filtered.json": 310,
	"./SpellBowl/Grade11/2026/premium0/Senior Word List 2026.json": 311,
	"./SpellBowl/Grade11/2026/premium0/Senior Word List 2026.json with hyphens and spaces.json": 312,
	"./SpellBowl/Grade11/2026/premium0/Senior Word List 2026.json with upper cases.json": 313,
	"./SpellBowl/Grade12/2021/premium300/SpellBowl0.json": 314,
	"./SpellBowl/Grade12/2021/premium300/SpellBowl01.json": 315,
	"./SpellBowl/Grade12/2021/premium300/SpellBowl100.json": 316,
	"./SpellBowl/Grade12/2021/premium300/SpellBowl150.json": 317,
	"./SpellBowl/Grade12/2021/premium300/SpellBowl200.json": 318,
	"./SpellBowl/Grade12/2021/premium300/SpellBowl250.json": 319,
	"./SpellBowl/Grade12/2021/premium300/SpellBowl300.json": 320,
	"./SpellBowl/Grade12/2021/premium300/SpellBowl350.json": 321,
	"./SpellBowl/Grade12/2021/premium300/SpellBowl400.json": 322,
	"./SpellBowl/Grade12/2021/premium300/SpellBowl450.json": 323,
	"./SpellBowl/Grade12/2021/premium300/SpellBowl50.json": 324,
	"./SpellBowl/Grade12/2021/premium300/SpellBowl500.json": 325,
	"./SpellBowl/Grade12/2021/premium300/SpellBowl550.json": 326,
	"./SpellBowl/Grade12/2021/premium300/SpellBowl600.json": 327,
	"./SpellBowl/Grade12/2021/premium300/SpellBowl650.json": 328,
	"./SpellBowl/Grade12/2021/premium300/SpellBowl700.json": 329,
	"./SpellBowl/Grade12/2022/premium300/Spell_Bowl_Elementary_2022_with_meanings.json": 330,
	"./SpellBowl/Grade12/2022/premium300/spellbowlelementary_2022_100.json": 331,
	"./SpellBowl/Grade12/2022/premium300/spellbowlelementary_2022_150.json": 332,
	"./SpellBowl/Grade12/2022/premium300/spellbowlelementary_2022_200.json": 333,
	"./SpellBowl/Grade12/2022/premium300/spellbowlelementary_2022_250.json": 334,
	"./SpellBowl/Grade12/2022/premium300/spellbowlelementary_2022_300.json": 335,
	"./SpellBowl/Grade12/2022/premium300/spellbowlelementary_2022_350.json": 336,
	"./SpellBowl/Grade12/2022/premium300/spellbowlelementary_2022_400.json": 337,
	"./SpellBowl/Grade12/2022/premium300/spellbowlelementary_2022_450.json": 338,
	"./SpellBowl/Grade12/2022/premium300/spellbowlelementary_2022_50.json": 339,
	"./SpellBowl/Grade12/2022/premium300/spellbowlelementary_2022_500.json": 340,
	"./SpellBowl/Grade12/2022/premium300/spellbowlelementary_2022_550.json": 341,
	"./SpellBowl/Grade12/2022/premium300/spellbowlelementary_2022_600.json": 342,
	"./SpellBowl/Grade12/2022/premium300/spellbowlelementary_2022_650.json": 343,
	"./SpellBowl/Grade12/2022/premium300/spellbowlelementary_2022_700.json": 344,
	"./SpellBowl/Grade12/2022/premium300/spellbowlelementary_2022_750.json": 345,
	"./SpellBowl/Grade12/2023/premium300/Senior Word List 2023.json": 346,
	"./SpellBowl/Grade12/2024/premium300/AI Generated Complex Senior Word List 2024.json": 347,
	"./SpellBowl/Grade12/2024/premium300/Senior Word List 2024 with hyphens and spaces.json": 348,
	"./SpellBowl/Grade12/2024/premium300/Senior Word List 2024 with hyphens.json": 349,
	"./SpellBowl/Grade12/2024/premium300/Senior Word List 2024 with spaces.json": 350,
	"./SpellBowl/Grade12/2024/premium300/Senior Word List 2024 with upper cases.json": 351,
	"./SpellBowl/Grade12/2024/premium300/Senior Word List 2024.json": 352,
	"./SpellBowl/Grade12/2025/premium1000/Senior Word List 2025.json": 353,
	"./SpellBowl/Grade12/2025/premium1000/Senior Word List 2025.json with hyphens and spaces.json": 354,
	"./SpellBowl/Grade12/2025/premium1000/Senior Word List 2025.json with upper cases.json": 355,
	"./SpellBowl/Grade12/2025/premium1000/Senior Word List 2025_filtered.json": 356,
	"./SpellBowl/Grade12/2026/premium0/Senior Word List 2026.json": 357,
	"./SpellBowl/Grade12/2026/premium0/Senior Word List 2026.json with hyphens and spaces.json": 358,
	"./SpellBowl/Grade12/2026/premium0/Senior Word List 2026.json with upper cases.json": 359,
	"./SpellBowl/Grade4/2023/premium300/Elementary Word List 2023.json": 360,
	"./SpellBowl/Grade4/2024/premium300/AI Generated Complex Elementary Word List 2024.json": 361,
	"./SpellBowl/Grade4/2024/premium300/Elementary Word List 2024 with hyphens and spaces.json": 362,
	"./SpellBowl/Grade4/2024/premium300/Elementary Word List 2024 with hyphens.json": 363,
	"./SpellBowl/Grade4/2024/premium300/Elementary Word List 2024 with spaces.json": 364,
	"./SpellBowl/Grade4/2024/premium300/Elementary Word List 2024 with upper cases.json": 365,
	"./SpellBowl/Grade4/2024/premium300/Elementary Word List 2024.json": 366,
	"./SpellBowl/Grade4/2025/premium10000/Elementary Word List 2025.json": 367,
	"./SpellBowl/Grade4/2025/premium10000/Elementary Word List 2025.json with hyphens and spaces.json": 368,
	"./SpellBowl/Grade4/2025/premium10000/Elementary Word List 2025.json with upper cases.json": 369,
	"./SpellBowl/Grade4/2025/premium10000/Elementary Word List 2025_filtered.json": 370,
	"./SpellBowl/Grade4/2026/premium0/Elementary Word List 2026.json": 371,
	"./SpellBowl/Grade4/2026/premium0/Elementary Word List 2026.json with hyphens and spaces.json": 372,
	"./SpellBowl/Grade4/2026/premium0/Elementary Word List 2026.json with upper cases.json": 373,
	"./SpellBowl/Grade5/2021/premium300/SpellBowl0.json": 374,
	"./SpellBowl/Grade5/2021/premium300/SpellBowl01.json": 375,
	"./SpellBowl/Grade5/2021/premium300/SpellBowl100.json": 376,
	"./SpellBowl/Grade5/2021/premium300/SpellBowl150.json": 377,
	"./SpellBowl/Grade5/2021/premium300/SpellBowl200.json": 378,
	"./SpellBowl/Grade5/2021/premium300/SpellBowl250.json": 379,
	"./SpellBowl/Grade5/2021/premium300/SpellBowl300.json": 380,
	"./SpellBowl/Grade5/2021/premium300/SpellBowl350.json": 381,
	"./SpellBowl/Grade5/2021/premium300/SpellBowl400.json": 382,
	"./SpellBowl/Grade5/2021/premium300/SpellBowl450.json": 383,
	"./SpellBowl/Grade5/2021/premium300/SpellBowl50.json": 384,
	"./SpellBowl/Grade5/2021/premium300/SpellBowl500.json": 385,
	"./SpellBowl/Grade5/2021/premium300/SpellBowl550.json": 386,
	"./SpellBowl/Grade5/2021/premium300/SpellBowl600.json": 387,
	"./SpellBowl/Grade5/2021/premium300/SpellBowl650.json": 388,
	"./SpellBowl/Grade5/2021/premium300/SpellBowl700.json": 389,
	"./SpellBowl/Grade5/2022/premium300/Spell_Bowl_Elementary_2022_with_meanings.json": 390,
	"./SpellBowl/Grade5/2022/premium300/spellbowlelementary_2022_100.json": 391,
	"./SpellBowl/Grade5/2022/premium300/spellbowlelementary_2022_150.json": 392,
	"./SpellBowl/Grade5/2022/premium300/spellbowlelementary_2022_200.json": 393,
	"./SpellBowl/Grade5/2022/premium300/spellbowlelementary_2022_250.json": 394,
	"./SpellBowl/Grade5/2022/premium300/spellbowlelementary_2022_300.json": 395,
	"./SpellBowl/Grade5/2022/premium300/spellbowlelementary_2022_350.json": 396,
	"./SpellBowl/Grade5/2022/premium300/spellbowlelementary_2022_400.json": 397,
	"./SpellBowl/Grade5/2022/premium300/spellbowlelementary_2022_450.json": 398,
	"./SpellBowl/Grade5/2022/premium300/spellbowlelementary_2022_50.json": 399,
	"./SpellBowl/Grade5/2022/premium300/spellbowlelementary_2022_500.json": 400,
	"./SpellBowl/Grade5/2022/premium300/spellbowlelementary_2022_550.json": 401,
	"./SpellBowl/Grade5/2022/premium300/spellbowlelementary_2022_600.json": 402,
	"./SpellBowl/Grade5/2022/premium300/spellbowlelementary_2022_650.json": 403,
	"./SpellBowl/Grade5/2022/premium300/spellbowlelementary_2022_700.json": 404,
	"./SpellBowl/Grade5/2022/premium300/spellbowlelementary_2022_750.json": 405,
	"./SpellBowl/Grade5/2023/premium300/Elementary Word List 2023.json": 406,
	"./SpellBowl/Grade5/2024/premium500/AI Generated Complex Elementary Word List 2024.json": 407,
	"./SpellBowl/Grade5/2024/premium500/Elementary Word List 2024 with hyphens and spaces.json": 408,
	"./SpellBowl/Grade5/2024/premium500/Elementary Word List 2024 with hyphens.json": 409,
	"./SpellBowl/Grade5/2024/premium500/Elementary Word List 2024 with spaces.json": 410,
	"./SpellBowl/Grade5/2024/premium500/Elementary Word List 2024 with upper cases.json": 411,
	"./SpellBowl/Grade5/2024/premium500/Elementary Word List 2024.json": 412,
	"./SpellBowl/Grade5/2025/premium1000/Elementary Word List 2025 with hyphens and spaces.json": 413,
	"./SpellBowl/Grade5/2025/premium1000/Elementary Word List 2025.json": 414,
	"./SpellBowl/Grade5/2025/premium1000/Elementary Word List 2025.json with upper cases.json": 415,
	"./SpellBowl/Grade5/2025/premium1000/Elementary Word List 2025_filtered.json": 416,
	"./SpellBowl/Grade5/2026/premium0/Elementary Word List 2026.json": 417,
	"./SpellBowl/Grade5/2026/premium0/Elementary Word List 2026.json with hyphens and spaces.json": 418,
	"./SpellBowl/Grade5/2026/premium0/Elementary Word List 2026.json with upper cases.json": 419,
	"./SpellBowl/Grade6/2022/premium300/CommonlyMissedJunior.json": 420,
	"./SpellBowl/Grade6/2022/premium300/Spell_Bowl_Junior_2022_with_meanings.json": 421,
	"./SpellBowl/Grade6/2022/premium300/spellbowljunior_2022_100.json": 422,
	"./SpellBowl/Grade6/2022/premium300/spellbowljunior_2022_1000.json": 423,
	"./SpellBowl/Grade6/2022/premium300/spellbowljunior_2022_1050.json": 424,
	"./SpellBowl/Grade6/2022/premium300/spellbowljunior_2022_1100.json": 425,
	"./SpellBowl/Grade6/2022/premium300/spellbowljunior_2022_1150.json": 426,
	"./SpellBowl/Grade6/2022/premium300/spellbowljunior_2022_1200.json": 427,
	"./SpellBowl/Grade6/2022/premium300/spellbowljunior_2022_1250.json": 428,
	"./SpellBowl/Grade6/2022/premium300/spellbowljunior_2022_1300.json": 429,
	"./SpellBowl/Grade6/2022/premium300/spellbowljunior_2022_1350.json": 430,
	"./SpellBowl/Grade6/2022/premium300/spellbowljunior_2022_1400.json": 431,
	"./SpellBowl/Grade6/2022/premium300/spellbowljunior_2022_150.json": 432,
	"./SpellBowl/Grade6/2022/premium300/spellbowljunior_2022_200.json": 433,
	"./SpellBowl/Grade6/2022/premium300/spellbowljunior_2022_250.json": 434,
	"./SpellBowl/Grade6/2022/premium300/spellbowljunior_2022_300.json": 435,
	"./SpellBowl/Grade6/2022/premium300/spellbowljunior_2022_350.json": 436,
	"./SpellBowl/Grade6/2022/premium300/spellbowljunior_2022_400.json": 437,
	"./SpellBowl/Grade6/2022/premium300/spellbowljunior_2022_450.json": 438,
	"./SpellBowl/Grade6/2022/premium300/spellbowljunior_2022_50.json": 439,
	"./SpellBowl/Grade6/2022/premium300/spellbowljunior_2022_500.json": 440,
	"./SpellBowl/Grade6/2022/premium300/spellbowljunior_2022_550.json": 441,
	"./SpellBowl/Grade6/2022/premium300/spellbowljunior_2022_600.json": 442,
	"./SpellBowl/Grade6/2022/premium300/spellbowljunior_2022_650.json": 443,
	"./SpellBowl/Grade6/2022/premium300/spellbowljunior_2022_700.json": 444,
	"./SpellBowl/Grade6/2022/premium300/spellbowljunior_2022_750.json": 445,
	"./SpellBowl/Grade6/2022/premium300/spellbowljunior_2022_800.json": 446,
	"./SpellBowl/Grade6/2022/premium300/spellbowljunior_2022_850.json": 447,
	"./SpellBowl/Grade6/2022/premium300/spellbowljunior_2022_900.json": 448,
	"./SpellBowl/Grade6/2022/premium300/spellbowljunior_2022_950.json": 449,
	"./SpellBowl/Grade6/2023/premium300/Junior Word List 2023.json": 450,
	"./SpellBowl/Grade6/2024/premium300/AI Generated Complex Junior Word List 2024.json": 451,
	"./SpellBowl/Grade6/2024/premium300/Junior Word List 2024 with hyphens and spaces.json": 452,
	"./SpellBowl/Grade6/2024/premium300/Junior Word List 2024 with hyphens.json": 453,
	"./SpellBowl/Grade6/2024/premium300/Junior Word List 2024 with spaces.json": 454,
	"./SpellBowl/Grade6/2024/premium300/Junior Word List 2024 with upper cases.json": 455,
	"./SpellBowl/Grade6/2024/premium300/Junior Word List 2024.json": 456,
	"./SpellBowl/Grade6/2025/premium1000/Junior Word List 2025.json": 457,
	"./SpellBowl/Grade6/2025/premium1000/Junior Word List 2025.json with hyphens and spaces.json": 458,
	"./SpellBowl/Grade6/2025/premium1000/Junior Word List 2025.json with upper cases.json": 459,
	"./SpellBowl/Grade6/2025/premium1000/Junior Word List 2025_filtered.json": 460,
	"./SpellBowl/Grade6/2026/premium0/Junior Word List 2026.json": 461,
	"./SpellBowl/Grade6/2026/premium0/Junior Word List 2026.json with hyphens and spaces.json": 462,
	"./SpellBowl/Grade6/2026/premium0/Junior Word List 2026.json with upper cases.json": 463,
	"./SpellBowl/Grade7/2023/premium200/Junior Word List 2023.json": 464,
	"./SpellBowl/Grade7/2023/premium300/Junior Word List 2023_both.json": 465,
	"./SpellBowl/Grade7/2023/premium300/Junior Word List 2023_hyphen.json": 466,
	"./SpellBowl/Grade7/2023/premium300/Junior Word List 2023_space.json": 467,
	"./SpellBowl/Grade7/2024/premium200/AI Generated Complex Junior Word List 2024.json": 468,
	"./SpellBowl/Grade7/2024/premium200/Junior Word List 2024 with hyphens and spaces.json": 469,
	"./SpellBowl/Grade7/2024/premium200/Junior Word List 2024 with hyphens.json": 470,
	"./SpellBowl/Grade7/2024/premium200/Junior Word List 2024 with spaces.json": 471,
	"./SpellBowl/Grade7/2024/premium200/Junior Word List 2024 with upper cases.json": 472,
	"./SpellBowl/Grade7/2024/premium200/Junior Word List 2024.json": 473,
	"./SpellBowl/Grade7/2025/premium1000/Junior Word List 2025.json": 474,
	"./SpellBowl/Grade7/2025/premium1000/Junior Word List 2025.json with hyphens and spaces.json": 475,
	"./SpellBowl/Grade7/2025/premium1000/Junior Word List 2025.json with upper cases.json": 476,
	"./SpellBowl/Grade7/2025/premium1000/Junior Word List 2025_filtered.json": 477,
	"./SpellBowl/Grade7/2026/premium0/Junior Word List 2026.json": 478,
	"./SpellBowl/Grade7/2026/premium0/Junior Word List 2026.json with hyphens and spaces.json": 479,
	"./SpellBowl/Grade7/2026/premium0/Junior Word List 2026.json with upper cases.json": 480,
	"./SpellBowl/Grade8/2023/premium300/Junior Word List 2023.json": 481,
	"./SpellBowl/Grade8/2024/premium300/AI Generated Complex Junior Word List 2024.json": 482,
	"./SpellBowl/Grade8/2024/premium300/Junior Word List 2024 with hyphens and spaces.json": 483,
	"./SpellBowl/Grade8/2024/premium300/Junior Word List 2024 with hyphens.json": 484,
	"./SpellBowl/Grade8/2024/premium300/Junior Word List 2024 with spaces.json": 485,
	"./SpellBowl/Grade8/2024/premium300/Junior Word List 2024 with upper cases.json": 486,
	"./SpellBowl/Grade8/2024/premium300/Junior Word List 2024.json": 487,
	"./SpellBowl/Grade8/2025/premium0/Junior Word List 2025.json": 488,
	"./SpellBowl/Grade8/2025/premium0/Junior Word List 2025.json with hyphens and spaces.json": 489,
	"./SpellBowl/Grade8/2025/premium0/Junior Word List 2025.json with upper cases.json": 490,
	"./SpellBowl/Grade8/2025/premium0/Junior Word List 2025_filtered.json": 491,
	"./SpellBowl/Grade8/2026/premium0/Junior Word List 2026.json": 492,
	"./SpellBowl/Grade8/2026/premium0/Junior Word List 2026.json with hyphens and spaces.json": 493,
	"./SpellBowl/Grade8/2026/premium0/Junior Word List 2026.json with upper cases.json": 494,
	"./SpellBowl/Grade9/2022/premium300/Spell_Bowl_Senior_2022_with_meanings.json": 495,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_100.json": 496,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_1000.json": 497,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_1050.json": 498,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_1100.json": 499,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_1150.json": 500,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_1200.json": 501,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_1250.json": 502,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_1300.json": 503,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_1350.json": 504,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_1400.json": 505,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_1450.json": 506,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_150.json": 507,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_1500.json": 508,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_1550.json": 509,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_1600.json": 510,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_1650.json": 511,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_1700.json": 512,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_1750.json": 513,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_1800.json": 514,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_1850.json": 515,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_1900.json": 516,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_1950.json": 517,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_200.json": 518,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_2000.json": 519,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_2050.json": 520,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_2100.json": 521,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_2150.json": 522,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_2200.json": 523,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_250.json": 524,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_300.json": 525,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_350.json": 526,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_400.json": 527,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_450.json": 528,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_50.json": 529,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_500.json": 530,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_550.json": 531,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_600.json": 532,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_650.json": 533,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_700.json": 534,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_750.json": 535,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_800.json": 536,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_850.json": 537,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_900.json": 538,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_950.json": 539,
	"./SpellBowl/Grade9/2023/premium300/Senior Word List 2023.json": 540,
	"./SpellBowl/Grade9/2024/premium300/AI Generated Complex Senior Word List 2024.json": 541,
	"./SpellBowl/Grade9/2024/premium300/Senior Word List 2024 with hyphens and spaces.json": 542,
	"./SpellBowl/Grade9/2024/premium300/Senior Word List 2024 with hyphens.json": 543,
	"./SpellBowl/Grade9/2024/premium300/Senior Word List 2024 with spaces.json": 544,
	"./SpellBowl/Grade9/2024/premium300/Senior Word List 2024 with upper cases.json": 545,
	"./SpellBowl/Grade9/2024/premium300/Senior Word List 2024.json": 546,
	"./SpellBowl/Grade9/2025/premium1000/Senior Word List 2025 with hyphens and spaces.json": 547,
	"./SpellBowl/Grade9/2025/premium1000/Senior Word List 2025 with upper cases.json": 548,
	"./SpellBowl/Grade9/2025/premium1000/Senior Word List 2025.json": 549,
	"./SpellBowl/Grade9/2025/premium1000/Senior Word List 2025_filtered.json": 550,
	"./SpellBowl/Grade9/2026/premium0/Senior Word List 2026.json": 551,
	"./SpellBowl/Grade9/2026/premium0/Senior Word List 2026.json with hyphens and spaces.json": 552,
	"./SpellBowl/Grade9/2026/premium0/Senior Word List 2026.json with upper cases.json": 553
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 212;